<div id="parameters-header" class="top-nav">
  <div class="container">
    <div class="row">
      <div class="col-3 col-lg-2 logo">
        <a [routerLink]="['/dashboard']">
          <img style="border: none;" src="../../../assets/icon/tchek-blue.svg" width="101px" height="27px" alt="">
        </a>
      </div>
      <div class="col-9 col-lg-10">
        <div class="header-wrapper">
          <div *ngIf="!showParameters" [ngClass]="{'active':activeSection==='parameters-user'}" class="section-link"
            (click)="scrollTo('parameters-user')"><span i18n="parameters-scrollspy|@@user">Utilisateur</span>
          </div>
          <div *ngIf="showParameters || privateCompany" [ngClass]="{'active':activeSection==='parameters-company'}"
            class="section-link" (click)="scrollTo('parameters-company')"><span
              i18n="parameters-scrollspy|@@company">Compagnie</span>
          </div>
          <div [ngClass]="{'active':activeSection==='parameters-accessibility'}" class="section-link"
            (click)="scrollTo('parameters-accessibility')"><span
              i18n="parameters-scrollspy|@@accessibility">Accessibilité</span>
          </div>
          <div id="parameters-reports-header" [ngClass]="{'active':activeSection==='parameters-reports'}"
            class="section-link" (click)="scrollTo('parameters-reports')">
            <span i18n="parameters-header|@@report_settings">Gestion des rapports</span>
          </div>
          <div *ngIf="showParameters" id="parameters-options-header"
            [ngClass]="{'active':activeSection==='parameters-options'}" class="section-link"
            (click)="scrollTo('parameters-options')">
            <span i18n="parameters-header|@@options_settings">Gestion des options</span>
          </div>
          <div id="parameters-style-header" [ngClass]="{'active':activeSection==='parameters-style'}"
            class="section-link" (click)="scrollTo('parameters-style')">
            <span i18n="parameters-header|@@custom_style">Style Personnalisé</span>
          </div>
          <div *ngIf="showParameters" id="parameters-users-header"
            [ngClass]="{'active':activeSection==='parameters-users'}" class="section-link"
            (click)="scrollTo('parameters-users')">
            <span i18n="parameters-header|@@users">Utilisateurs</span>
          </div>
          <div *ngIf="showParameters" id="parameters-vehicle-header"
            [ngClass]="{'active':activeSection==='parameters-vehicle'}" class="section-link"
            (click)="scrollTo('parameters-vehicle')">
            <span i18n="parameters-header|@@vehicle">Véhicule</span>
          </div>
          <div *ngIf="showParameters" id="parameters-checkList-header"
            [ngClass]="{'active':activeSection==='parameters-checkList'}" class="section-link"
            (click)="scrollTo('parameters-checkList')">
            <span i18n="parameters-header|@@checkList">CheckList</span>
          </div>
          <div *ngIf="showParameters" id="parameters-cost-header"
            [ngClass]="{'active':activeSection==='parameters-cost'}" class="section-link"
            (click)="scrollTo('parameters-cost')">
            <span i18n="parameters-header|@@cost">Chiffrage</span>
          </div>
          <div *ngIf="showParameters" id="parameters-tires-header"
            [ngClass]="{'active':activeSection==='parameters-tires'}" class="section-link"
            (click)="scrollTo('parameters-tires')">
            <span i18n="parameters-header|@@tires">Pneus</span> <span>
              <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Lock</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-511.000000, -2904.000000)" fill-rule="nonzero">
                    <g id="Content" transform="translate(165.000000, 269.000000)">
                      <g id="07" transform="translate(285.000000, 2632.000000)">
                        <g id="Title" transform="translate(1.000000, 0.000000)">
                          <path
                            d="M67,3 C64.8,3 63,4.8 63,7 L63,8 L61,8 C60.4,8 60,8.4 60,9 L60,18 C60,18.6 60.4,19 61,19 L73,19 C73.6,19 74,18.6 74,18 L74,9 C74,8.4 73.6,8 73,8 L71,8 L71,7 C71,4.8 69.2,3 67,3 Z M68,14.7 L68,16 L66,16 L66,14.7 C65.4,14.4 65,13.7 65,13 C65,11.9 65.9,11 67,11 C68.1,11 69,11.9 69,13 C69,13.7 68.6,14.4 68,14.7 Z M69,8 L65,8 L65,7 C65,5.9 65.9,5 67,5 C68.1,5 69,5.9 69,7 L69,8 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
          </div>
          <div id="parameters-notifications-header" [ngClass]="{'active':activeSection==='parameters-notifications'}"
            class="section-link" (click)="scrollTo('parameters-notifications')">
            <span i18n="parameters-header|@@notifications">Notifications</span>
          </div>
          <div id="parameters-language-header" [ngClass]="{'active':activeSection==='parameters-language'}"
            class="section-link" (click)="scrollTo('parameters-language')">
            <span i18n="parameters-header|@@language">Langue</span>
          </div>
          <div *ngIf="showParameters" id="parameters-apiwebhook-header"
            [ngClass]="{'active':activeSection==='parameters-apiwebhook'}" class="section-link"
            (click)="scrollTo('parameters-apiwebhook')">
            <span i18n="parameters-header|@@api_key_and_webhook">Clé API & Webhook</span>
          </div>
          <div *ngIf="isSuperAdmin" id="parameters-exportkpi-header"
            [ngClass]="{'active':activeSection==='parameters-exportkpi'}" class="section-link"
            (click)="scrollTo('parameters-exportkpi')">
            <span i18n="parameters-header|@@exportKpi">Export KPI</span>
          </div>
          <div id="parameters-apiwebhook-session" [ngClass]="{'active':activeSection==='parameters-session'}"
            class="section-link " (click)="scrollTo('parameters-session')"><span
              i18n="parameters-scrollspy|@@session">Session</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-header/parameters-header.component.html